
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi choisir la vidéo dans votre stratégie d'entreprise ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment la vidéo dynamise votre communication d'entreprise, capte l'attention et favorise l'engagement de votre audience pour des résultats optimaux",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Pourquoi utiliser la vidéo dans votre communication d’entreprise ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Une communication adaptée aux entreprises, voilà qui fait rêver. Depuis plusieurs années, la communication corporate a le vent en poupe. Efficace, elle met en perspective un marketing professionnel qui accorde de l’importance aux détails.",
        },
      ],
    };
  },
};
